import { transformPointToCXCY, OppColorCvrtCIExy2sRgb, transformPointToSdlRgb, rgbToHex } from '@/components/DesignCanvas/utils/common';
import { srgbTransXYZ, transXYZtoCxCy, transRgbToCxCy, handlerMatrixAction } from '@/components/DesignCanvas/utils/common';
import { transRgbToCxCyV2 } from '@/components/DesignCanvas/utils/transSdlColor';

/**
 * 获取快速算法
 * @param {*} param0 
 * stageSize 容器宽高, 
 * col 列, 
 * row 行, 
 * scale 高宽比
 * @returns 
 */
export function getRuleSize({ stageSize, col, row, scale }) {
  const total = col * row;
  const allWith = col;
  const allHeight = row * scale;
  let singleWidth = 0;
  let singleHeight = 0;
  let left = 0;
  let top = 0;
  let unitScale = 1;

  if (allWith > allHeight) {
    singleWidth = stageSize / col;
    singleHeight = singleWidth * scale;
    top = (stageSize - singleHeight * row) / 2;
    unitScale = col;
  } else {
    singleHeight = stageSize / row;
    singleWidth = singleHeight / scale;
    left = (stageSize - singleWidth * col) / 2;
    unitScale = row;
  };

  const data = {
    singleWidth,
    singleHeight,
    allWidth: singleWidth * col,
    allHeight: singleHeight * row,
    left,
    top,
    total,
    unitScale
  }
  return data;
  // const size = Math.floor(300 / Math.max(col, row * scale));
  
};

function rgbToCxcyValue(r, g, b, matrixValueUi = {}) {
  // const { X, Y, Z } = srgbTransXYZ(r, g, b);

  // v1 第一个版本
  const CxCy = transRgbToCxCy(r, g, b);
 
  const [cx, cy] = CxCy
  const dstPoint = { x: 0, y: 0 }
  let aa = 0;
  let bb = 0;

  // if (point.mode === 'V2') {
    // v2 第二个版本
    transRgbToCxCyV2(cx, cy, handlerMatrixAction(matrixValueUi), dstPoint);

    aa = dstPoint.x * 10000
    bb = dstPoint.y * 10000
  // } else {
  //   aa = cx * 10000
  //   bb = cy * 10000
  // }

  // aa = cx * 10000
  // bb = cy * 10000
  
  const value = (aa & 0x0000FFFF) << 16 | bb & 0x0000FFFF;

  return value


  // const d = transRgbToCxCy(r, g, b);

  // return parseInt(d, 16);
};

export function hexToRgb(hex) {
  // 移除十六进制颜色中的'#'
  let sanitizedHex = hex.replace("#", "");
 
  // 解析红、绿、蓝分量
  let r = parseInt(sanitizedHex.substring(0, 2), 16);
  let g = parseInt(sanitizedHex.substring(2, 4), 16);
  let b = parseInt(sanitizedHex.substring(4, 6), 16);

  return {
    r,
    g,
    b,
    rgb: `rgb(${r}, ${g}, ${b})`
  };
}

/**
 * 获取对应点位颜色以及各种布局信息
 * @param {*} imageUrl 
 * @param {*} positionList 
 * @param {*} option 
 * @returns 
 */
export function getPixelColor(imageUrl, positionList, option = null) {
  if (!imageUrl) {
    return Promise.resolve({
        bgStyle: {},
        colorList: [],
        hexList: [],
        cxcyValueList: []
      });
  }

  // 背景图放大缩小的数据
  const splicingBgStyle = option?.splicingBgStyle || {};
  // 背景图的放大比例
  const scale = splicingBgStyle.scale || 1;
  // 背景图左右移动比例
  const moveX = parseInt(splicingBgStyle.left || 0);
  const moveY = parseInt(splicingBgStyle.top || 0);
  const col = option ? option.col : 1;
  const row = option ? option.row : 1;
  const isRender = option.isRender || false;
  const activeSplicingView = option ? option.activeSplicingView : 0;
  const singleWidth = option.singleWidth;
  const singleHeight = option.singleHeight;
  const matrixValueUi = option.matrixValueUi || {};

  // const unit = Math.max(col, row);

  // 小图的单位尺寸
  // const size = Math.floor(300 / unit);

  // 大图吸色图的单位尺寸
  // const previewSize = Math.floor(700 / unit);
  
  console.log('moveX moveY', moveX, moveY);

  return new Promise((resolve, reject) => {
    let img = new Image();

    img.crossOrigin = "Anonymous"; // 解决跨域问题
    img.src = imageUrl;
    img.onload = () => {
      // 用来画
      let canvas = document.getElementById('scene-lightColorSet_canvas');
      // 虚拟的 只吸不画
      let canvasVirtually = document.getElementById('scene-lightColorSet_canvas-virtually');

      const imgSize = img.width;
      const imgProps = img.height / img.width;
    
      // const imgUnitSize = Math.floor(imgSize / unit);
      
      let ctx = option?.ctx || canvas.getContext('2d');
      let ctxVirtually = option?.ctxVirtually || canvasVirtually.getContext('2d');
      const devicePixelRatio = 1; // window.devicePixelRatio || 1;

      // 起始x index
      const stX = (activeSplicingView % col);
      // 起始y index
      const stY = Math.floor(activeSplicingView / col);
      // 上传的图片和容器比例
      const containerScale = Math.max(imgSize / 300, 1);

      // 不算图片放大 移动的原始位置
      const canvasStOriginX = stX * (singleWidth / scale) * containerScale;
      const canvasStOriginY = stY * (singleHeight / scale) * containerScale;
      // 因为放大导致的移动
      const scaleTransX = (1 - (1 / scale)) * imgSize / 2;
      const scaleTransY = scaleTransX * imgProps;
      // 图片移动 以及 初始框移动导致的位移
      const moveTransX = ((moveX - option.left) / scale * containerScale * -1);
      const moveTransY = ((moveY - option.top) / scale * containerScale * -1);

      // console.log('getPixelColor 2', moveX, scale, containerScale , option.left, moveTransX);
      const canvasStX = canvasStOriginX + scaleTransX + moveTransX;
      const canvasStY = canvasStOriginY + scaleTransY + moveTransY;
      // console.log('getPixelColor 77', canvasStOriginX, scaleTrans, moveTransX, canvasStX, containerScale);
      // console.log('getPixelColor 77', canvasStOriginX + scaleTrans + moveTransX);
      // 用于计算app的绝对位置
      const absoluteStX = stX * singleWidth + option.left;
      const absoluteStY = stY * singleHeight + option.top;
      
      ctxVirtually.clearRect(0, 0, 700, 700 * option.deviceScale);

      const canvasSizeX = Math.floor(singleWidth / scale * containerScale);
      const canvasSizeY = Math.floor(singleHeight / scale * containerScale);

      if (isRender) {
        ctx.clearRect(0, 0, 700, 700 * option.deviceScale);

        ctx.drawImage(
          img, 
          canvasStX, 
          canvasStY, 
          canvasSizeX, 
          canvasSizeY,
          0, 
          0, 
          700, 
          700 * option.deviceScale // 此处是设备的尺寸
        );

        console.log('getPixelColor 3', 
          canvasStX, 
          canvasStY, 
          canvasSizeX, 
          canvasSizeY,
          700 * option.deviceScale
        );
      };

  
      ctxVirtually.drawImage(
        img, 
        canvasStX, 
        canvasStY, 
        canvasSizeX, 
        canvasSizeY, 
        0,
        0, 
        700, 
        700 * option.deviceScale // 此处是设备的尺寸
      );

      // console.log('drawImage', stX * (imgUnitSize / scale), trans, moveX / scale * -1, imgUnitSize);
      // console.log('drawImage', stX * (imgUnitSize / scale) + trans + (moveX / scale  * 1.333 * -1), stY * (imgUnitSize / scale) + trans + (moveY / scale * 1.333 * -1), imgUnitSize / scale, imgUnitSize / scale);
      // console.log('drawImage ========================================================================================================================');

      const colorList = [];
      const hexList = [];
      const cxcyValueList = [];
      
      // console.log('this.renderList aa', positionList);
      
      positionList.forEach(item => {
        const { position } = item;
        const _x = Math.floor(position.x * devicePixelRatio);
        const _y = Math.floor(position.y * devicePixelRatio);

        const unitScale = singleWidth / 700;
        // position.pX = Math.floor(absoluteStX + _x * 300 / 700 / unit);
        // position.pY = Math.floor(absoluteStY + _y * 300 / 700 / unit);
        position.pX = Math.floor(absoluteStX + (_x * unitScale));
        position.pY = Math.floor(absoluteStY + (_y * unitScale));
        
        console.log('prop prop', position.pX, absoluteStX, unitScale);
        let pixelData = ctxVirtually.getImageData(_x + 11, _y + 11, 1, 1).data;

        colorList.push({
          r: pixelData[0],
          g: pixelData[1],
          b: pixelData[2],
        });

        hexList.push(rgbToHex(pixelData[0], pixelData[1], pixelData[2]));
        console.log('cxcyValueList cxcyValueList', pixelData[0], pixelData[1], pixelData[2], rgbToCxcyValue(pixelData[0], pixelData[1], pixelData[2]), matrixValueUi);
        cxcyValueList.push(rgbToCxcyValue(pixelData[0], pixelData[1], pixelData[2], matrixValueUi));
      });

      let splicingBgStyleWidth = img.width;
      let splicingBgStyleHeight = img.height;

      // if (img.width > img.height) {
      //   splicingBgStyleWidth = 300;
      //   splicingBgStyleHeight = Math.floor(img.height / img.width * 300);
      // } else {
      //   splicingBgStyleHeight = 300;
      //   splicingBgStyleWidth = Math.floor(img.width / img.height * 300);
      // }

      splicingBgStyleWidth = 300;
      splicingBgStyleHeight = Math.floor(img.height / img.width * 300);

      resolve({
        bgStyle: {
          // width: `${_width}px`,
          // height: `${_height}px`,
          // scale: unit * scale,
          // left: stX * -700 + (-700 * (scale - 1)) + 'px',
          // top: stY * -700 + (-700 * (scale - 1)) + 'px',
          // transformOrigin: 'top left'
        },
        splicingBgStyle: {
          width: splicingBgStyleWidth + 'px',
          height: splicingBgStyleHeight + 'px',
        },
        colorList,
        hexList,
        cxcyValueList,
        ctx,
        ctxVirtually
      });
    };
    img.onerror = reject;
  });
}